/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalCellularAlt1Bar: {
  name: 'signal-cellular-alt-1-bar';
  data: string;
} = {
  name: 'signal-cellular-alt-1-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5 14h3v6H5v-6z"/></svg>`
};
